import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Spinner } from 'react-bootstrap';

import TotalResponsesCounter from './TotalResponsesCounter';
import CompletedResponsesCounter from './CompletedResponsesCounter';
import IncompleteResponsesCounter from './IncompleteResponsesCounter';
import { getSurveyResponseStats } from 'services/reports'; // Servicio que devuelve las estadísticas

const SurveyCounters = ({ surveyId }) => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (surveyId === 0) {
      setStats(null);
      return;
    }

    setLoading(true);
    getSurveyResponseStats(surveyId) // Llama al servicio que devuelve las estadísticas
      .then(response => {
        if (response.result) {
          setStats(response.stats); // Guarda las estadísticas en el estado
        } else {
          setStats(null);
        }
      })
      .catch(error => {
        console.error(
          'Error al obtener las estadísticas de la encuesta:',
          error
        );
        setStats(null);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [surveyId]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center py-5">
        <Spinner animation="border" role="status" className="text-primary">
          <span className="visually-hidden">Cargando...</span>
        </Spinner>
      </div>
    );
  }

  if (!stats) {
    return (
      <div className="text-center py-3 text-muted">
        Selecciona una encuesta para ver los datos.
      </div>
    );
  }

  return (
    <Row className="g-3  ">
      <Col xs={12} md={6}>
        <TotalResponsesCounter count={stats.total} />
      </Col>
      <Col xs={6} md={3}>
        <CompletedResponsesCounter count={stats.complete} />
      </Col>
      <Col xs={6} md={3}>
        <IncompleteResponsesCounter count={stats.incomplete} />
      </Col>
    </Row>
  );
};

SurveyCounters.propTypes = {
  surveyId: PropTypes.number.isRequired // ID de la encuesta seleccionada
};

export default SurveyCounters;
